import { Chevron } from 'app/assets/icons'
import { media } from 'app/assets/styles'
import { Text } from 'app/common/typography'
import React, { Component } from 'react'
import type { IntlShape } from 'react-intl'
import { FormattedMessage, injectIntl } from 'react-intl'
import { colors as oldColors } from 'shared/assets/styles'
import { colors } from 'app-v2/design-systems/theme'
import styled from 'styled-components'

const { shadow } = oldColors

type Props = {
    label: string,
    url: string,
    urlParams: { [string]: any },
    duration?: number,
    color?: string,
    values?: number,
    resetToast: () => void,
    navigate: (to: string, state?: any) => void,
    intl: IntlShape
}

type State = {
    visible: boolean
}

class Toast extends Component<Props, State> {
    state = {
        visible: false
    }

    componentDidUpdate(prevProps: Props) {
        const { label } = this.props
        if (label && prevProps.label !== label) {
            this.setTimer()
        }
    }

    setTimer = () => {
        const { duration = 10000, resetToast } = this.props
        this.setState({ visible: true })
        setTimeout(() => {
            this.setState({ visible: false })
            resetToast()
        }, duration)
    }

    render() {
        const {
            label,
            url,
            urlParams,
            color = colors.crunchyGreen,
            values,
            navigate,
            intl
        } = this.props
        const { visible } = this.state

        if (!visible) {
            return null
        }

        return (
            <ToastLink
                color={color}
                onClick={() => {
                    url && navigate(intl.formatMessage({ id: url }), urlParams)
                    this.setState({ visible: false })
                }}>
                <Content>
                    <FormattedMessage id={label} values={{ values }}>
                        {(text: string) => (
                            <StyledText color="white" center>
                                {text}
                            </StyledText>
                        )}
                    </FormattedMessage>
                    <IconContainer>
                        <Chevron />
                    </IconContainer>
                </Content>
            </ToastLink>
        )
    }
}

const ToastLink = styled.div`
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100000;
    align-self: center;
    border-radius: 10px;
    padding: 10px;
    width: calc(100% - 40px);
    background-color: ${props => props.color};
    box-shadow: 0 0 5px ${shadow};
    top: 70px;
    cursor: pointer;
    ${media.medium`
        top: 100px;
        max-width: 25%;
        right: 20px;
        left: auto;
        transform: initial;
    `};
`

const StyledText = styled(Text)`
    padding: 0 20px;
`

const Content = styled.div`
    display: flex;
    position: relative;
    justify-content: center;
`

const IconContainer = styled.div`
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    font-size: 0;
`

export const ToastComponent = injectIntl(Toast)
